import script from "./TutorProfileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorProfileForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorProfileForm.vue?vue&type=style&index=0&id=563d09ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563d09ab"]])

export default __exports__